<template>
  <VCard elevation="1" class="body-2 avatar-only-card">
    <div class="pa-5">
      <div class="d-flex justify-center align-center avatar-only">
        <CompanyLogo :logo="company.logo" :title="company.name" :size="size" />
      </div>
    </div>
  </VCard>
</template>

<script>
import CompanyLogo from './CompanyLogo.vue';

export default {
  name: 'CompanyCard',
  components: {
    CompanyLogo,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 140,
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar-only {
  width: 100%;
  height: 0;
  padding-top: 100%;

  &::v-deep {
    > div {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(255,255,255, 0) !important;
      margin: 0 !important;
      @media screen and (max-width: 960px) {
        transform: translate(-25%, -40%);
        left: 10%;
        top: 10%;
      }
    }
  }
}

.avatar-only-card {
  background-color: rgba(255,255,255, 0) !important;
  box-shadow: none !important;
}
</style>
